import { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Header/Header";

import "../Snack/Snack.css";

const Support = () => {
  const [revealed, setRevealed] = useState(false);

  return (
    <>
      <Helmet>
        <title>1goodthing - Support</title>
        <meta name="description" content="1goodthing Support" />
      </Helmet>
      <div className="App">
        <Header showHome={true} />
        <h2>Support</h2>
        <div className="snack">
          <div className="snack-card">
            <h2>Get in Touch</h2>
            <p>
              Have a question, found a bug, or just want to say hi? Feel free
              to reach out.
            </p>
            {revealed ? (
              <p>
                <a href="mailto:james.bouker@gmail.com">
                  james.bouker@gmail.com
                </a>
              </p>
            ) : (
              <button onClick={() => setRevealed(true)}>Show Email</button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
